import {Button} from '@/components/ui/button/Button'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {DotsHorizontalIcon, PlusIcon} from '@/components/ui/icon/Icon'
import {Menu, MenuItem} from '@/components/ui/menu-atoms/MenuAtoms'
import {AgendaViewMenu} from '@/features/agenda/components/agenda-view-menu/AgendaViewMenu'
import {MenuButton, MenuProvider, useDialogStore} from '@ariakit/react'
import {CreateEventFormDialog} from '@/features/agenda/components/create-event-form-dialog/CreateEventFormDialog'
import {useTranslation} from '@/translations/i18n'
import {AddPatientAbsenceDialog} from '@/features/agenda/components/add-patient-absence-dialog/AddPatientAbsenceDialog'
import {AddConsultantAbsenceDialog} from '../add-consultant-absence-dialog/AddConsultantAbsenceDialog'
import {useAgendaCalendarStore} from '../../stores/agendaCalendarStore'
import {InputSelect} from '@/components/commons/input-select/InputSelect'
import {agendaEventStatusMapToLabel} from '@/features/agenda/utils'
import {useAgendaCategoryCustom} from '@/features/agenda/hooks/useAgendaCategoryCustom'
import {usePermissions} from '@/features/auth/store/store'
import {StyledAgendaToolbarOptions} from '@/features/agenda/components/agenda-calendar-toolbar/style'
import {useAgendaNavigation} from '../../hooks/useAgendaNavigation'

export const AgendaToolbarOptions = () => {
    const {t} = useTranslation()
    const patientAbsenceDialogStore = useDialogStore()
    const consultantAbsenceDialogStore = useDialogStore()
    const statusFilter = useAgendaCalendarStore(state => state.statusFilter)
    const setStatusFilter = useAgendaCalendarStore(state => state.setStatusFilter)
    const {
        params: {entity}
    } = useAgendaNavigation()
    const {subjects, isLoading} = useAgendaCategoryCustom()
    const permissions = usePermissions()

    return (
        <StyledAgendaToolbarOptions gap={3} align="center" justify="end">
            <Flexbox align="center">
                <InputSelect
                    optionsMap={agendaEventStatusMapToLabel}
                    value={statusFilter || undefined}
                    onChange={value => setStatusFilter(value)}
                    placeholder={t('agenda:select_status_filter')}
                    onClear={() => setStatusFilter(null)}
                    sameWidth={false}
                />
            </Flexbox>
            <AgendaViewMenu />
            {permissions?.agenda.write && (
                <>
                    <CreateEventFormDialog />
                    <MenuProvider>
                        <MenuButton
                            render={
                                <Button variant="secondary" size="md" shape="square">
                                    <DotsHorizontalIcon />
                                </Button>
                            }
                        />
                        <Menu>
                            <MenuItem onClick={() => patientAbsenceDialogStore.setOpen(true)}>
                                <PlusIcon />
                                {t('agenda:add_patient_absence')}
                            </MenuItem>
                            <MenuItem onClick={() => consultantAbsenceDialogStore.setOpen(true)}>
                                <PlusIcon />
                                {t('agenda:add_consultant_absence')}
                            </MenuItem>
                        </Menu>
                    </MenuProvider>
                </>
            )}
            {!isLoading && (
                <>
                    <AddPatientAbsenceDialog
                        dialogStore={patientAbsenceDialogStore}
                        selectedPatient={entity == 'patients' ? subjects[0] : null}
                    />
                    <AddConsultantAbsenceDialog
                        dialogStore={consultantAbsenceDialogStore}
                        selectedConsultant={entity == 'users' ? subjects[0] : null}
                    />
                </>
            )}
        </StyledAgendaToolbarOptions>
    )
}
